import angular from 'angular';
import uiRouter from 'angular-ui-router';
import mobileSearchComponent from './mobileSearch.component';

let mobileSearchModule = angular.module('mobileSearch', [
  uiRouter
])

.component('mobileSearch', mobileSearchComponent)

.name;

export default mobileSearchModule;
